import React from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';


import * as distributionsFormConstants from './distributionsFormConstants';
import * as distributionConstants from '../distributionConstants';

import Collapsible from '../../../../global/Collapsible';
import DistributionForm, {distributionFormConstants} from '../DistributionForm';
import FormActions from '../../../../global/Form/FormActions';
import ValidatingForm from '../../../../global/Form/ValidatingForm';
import {Button} from '../../../../global/Button';
import {I18nMessage} from '../../../I18n';
import {Icon, iconConstants} from '../../../../global/Icon';

import styles from './DistributionsForm.scss';


function DistributionsForm({distributions, formId, onData}) {

    // Forms can only deal with a top-level object, enhance later
    const internalValidationSchema = yup.object()
        .shape({
            distributions: distributionsFormConstants.SCHEMA_DISTRIBUTIONS
        });

    return (
        <ValidatingForm
            data={
                // see above
                {
                    distributions
                }
            }
            id={formId}
            onIsInvalid={({distributions}) => onData(distributions, false)}
            onIsValid={({distributions}) => onData(distributions, true)}
            validationSchema={internalValidationSchema}
        >
            {({form}) => {

                const distributions = form.getData('distributions');
                if (distributions.length === 1) {
                    distributions[0].isPrimary = true;
                }
                const primaryIndex = distributions.findIndex(({isPrimary}) => isPrimary);

                const addDistribution = () => {

                    /** @type {object} */
                    const newDistributionData = distributionFormConstants.SCHEMA_DISTRIBUTION.getDefaultFromShape();
                    newDistributionData.isPrimary = distributions.length === 0;

                    const updatedDistributions = form.getData('distributions');
                    updatedDistributions.push(newDistributionData);
                    form.setData({distributions: updatedDistributions});
                };

                const removeDistribution = distributionIndex => {

                    const updatedDistributions = form.getData('distributions')
                        .filter((data, index) => index !== distributionIndex);

                    // in case the distribution with the checkbox got removed, just the first one wins
                    if (updatedDistributions.findIndex(({isPrimary}) => isPrimary) === -1) {
                        updatedDistributions[0].isPrimary = true;
                    }

                    form.setData({distributions: updatedDistributions});
                };

                return (
                    <div className={styles.distributionsForm}>

                        <Collapsible
                            entries={
                                distributions.map((distribution, i) => {

                                    const isExpanded = distributions.length === 1;

                                    return {
                                        actions: (
                                            <>
                                                {distributions.length > 1 && (
                                                    <Button
                                                        cssClass={styles.entryDelete}
                                                        labelI18n={'distributions.form.remove'}
                                                        onClick={() => removeDistribution(i)}
                                                    />
                                                )}
                                            </>
                                        ),
                                        content: (
                                            <DistributionForm
                                                distribution={distribution}
                                                formId={`distribution${i}`}
                                                isPrimaryDisabled={i === primaryIndex}
                                                onData={updatedDistribution => {

                                                    let currentDistributions = form.getData('distributions');

                                                    // only one primary market
                                                    if (updatedDistribution.isPrimary) {
                                                        currentDistributions = currentDistributions.map(
                                                            distribution => {
                                                                distribution.isPrimary = false;

                                                                return distribution;
                                                            }
                                                        );
                                                    }
                                                    currentDistributions[i] = updatedDistribution;

                                                    form.setData({distributions: currentDistributions});
                                                }}
                                            />
                                        ),
                                        entry: (
                                            <h5>
                                                <I18nMessage
                                                    id={'distributions.form.distribution'}
                                                    values={
                                                        {
                                                            number: i + 1
                                                        }
                                                    }
                                                />
                                            </h5>
                                        ),
                                        isExpanded
                                    };
                                })
                            }
                        />

                        <FormActions cssClass={'inside'}>
                            <Button
                                iconEnd={<Icon icon={iconConstants.ICON_PLUS}/>}
                                labelI18n={'distributions.form.add'}
                                onClick={addDistribution}
                            />
                        </FormActions>

                    </div>
                );
            }}
        </ValidatingForm>
    );
}


DistributionsForm.propTypes = {
    distributions: distributionConstants.DISTRIBUTIONS_SHAPE,
    formId: PropTypes.string,
    onData: PropTypes.func.isRequired
};

DistributionForm.defaultProps = {
    formId: 'distributionsForm'
};


export default DistributionsForm;
